export enum ModGeneration {
    MOD1 = 'MOD1',
    MOD2 = 'MOD2',
    MOD2_5 = 'MOD2.5',
    MOD3 = 'MOD3',
    MOD3_1 = 'MOD3.1',
    MOD3_1_UNECE = 'MOD3.1UNECE',
    MOD3_2 = 'MOD3.2',
    MOD3_2_UNECE = 'MOD3.2UNECE',
    MOD3_5 = 'MOD3.5',
    MOD4 = 'MOD4',
    MOD5 = 'MOD5',
    MOD6 = 'MOD6',
    NA = 'NA',
    UNKNOWN = 'UNKNOWN',
}
